<script>
import { defineComponent, markRaw, nextTick, onMounted, ref } from "vue";
import { InjectionKeys, Functions, Utilities } from "@vue-leaflet/vue-leaflet";
import { vectorBasemapLayer } from "esri-leaflet-vector";
const { setupLayer, layerProps } = Functions.Layer;
const { AddLayerInjection } = InjectionKeys;
const { assertInject, propsBinder, remapEvents } = Utilities;

/**
 * Load tiles from a map server and display them accordingly to map zoom, center and size
 */
export default defineComponent({
  name: "EBasemapLayer",
  props: {
    ...layerProps,
    basemap: {
      type: String,
      required: true,
    },
    apikey: {
      type: String,
      required: true,
    },
  },
  setup(props, context) {
    const leafletObject = ref();

    const addLayer = assertInject(AddLayerInjection);

    const { methods } = setupLayer(props, leafletObject, context);

    // lifecycle
    onMounted(async () => {
      leafletObject.value = markRaw(
        vectorBasemapLayer(props.basemap, { ...props })
      );
      const { listeners } = remapEvents(context.attrs);
      leafletObject.value.on(listeners);

      propsBinder(methods, leafletObject.value, props);

      addLayer({
        ...props,
        ...methods,
        leafletObject: leafletObject.value,
      });
      await nextTick(() => context.emit("ready", leafletObject.value));
    });

    return { leafletObject };
  },
  render() {
    return null;
  },
});
</script>
